import * as React from 'react';
import Box from '@mui/material/Box';
import { repeatEffect , repeatEffectVms } from 'utils/commonFunc';
import ApiService from "services/ApiService";
import BoundaryMap from 'map/BoundaryMap';
import { ChipStack } from 'pages/components/ChipStack';
import ParentBox from 'pages/components/ParentBox';
import { Padding } from '@mui/icons-material';

const chipStyleVMS = {
    position: 'absolute',
   top: '-86px', 
   right: '0', 
   zIndex:'10'
};

export default function VmsDisplayView() {
    const mapRef = React.useRef();
    const [vmsGroups, setVmsGroups] = React.useState([]);
    const [selectedVmsGroup, setSelectedVmsGroup] = React.useState([]);
    const [boundaryGeoJson, setBoundaryGeoJson] = React.useState();

    React.useEffect(() => {
        ApiService.get("dashboard/Map/Boundary").then(response => {
            if (response.status === 200) {
                const data = response.data;
                setBoundaryGeoJson(data)
            }
        })
    }, []); 

    React.useEffect(() => {
        if(!boundaryGeoJson) 
            return

        ApiService.get("newdashboard/roadtraffic/GetItems?group=0&moduleType=0&project=0").then(response => {
            if (response.status === 200) {
                const data = response.data;

                const groups = [
                    {
                        typeName: '문자',                  
                        data: data.filter(p => p.project === 2)
                    },
                    {
                        typeName: '혼합',
                        data: data.filter(p => p.project === 4)
                    },
                    {
                        typeName: '도형1',
                        data: data.filter(p => p.project === 5 || p.project === 6)
                    },
                    {
                        typeName: '도형2',
                        data: data.filter(p => p.project === 7).slice(0, 6)
                    },
                    {
                        typeName: '도형3',
                        data: data.filter(p => p.project === 7).slice(6)
                    },
                ];
                setVmsGroups(groups)
            }
        });
    }, [boundaryGeoJson]);

    React.useEffect(() => {
        if(vmsGroups.length === 0)
            return
        
        let index = 0;
        return repeatEffectVms(
            () => {
                setSelectedVmsGroup(vmsGroups[index++])
                if (index === vmsGroups.length) {
                    index = 0
                }
            }, 
            10)
    }, [vmsGroups]);

    React.useEffect(() => {
        if(!selectedVmsGroup?.data)
            return

        if (mapRef?.current?.SetVmsItems) {
            mapRef.current.SetVmsItems(selectedVmsGroup.data);
        }  
    }, [selectedVmsGroup]);

    return (
        <div style={{ height: '100%', width: '100%', position: 'relative', overflow:'visible'}}>
            <ChipStack
                textItems={vmsGroups.map(group => group.typeName)}
                selectedText={selectedVmsGroup?.typeName}
                sx={chipStyleVMS}
            />
            <Box sx={{ height: '100%', width: '100%', display: 'grid',}}>
                <BoundaryMap
                ref={mapRef}
                boundaryGeoJson={boundaryGeoJson}
                initViewData={{ zoom: 13.0, center: [127.01288, 37.290] }}
                />
            </Box>
        </div>
    )
}


// mport * as React from 'react';
// import { repeatEffect } from 'utils/commonFunc';
// import ApiService from "services/ApiService";
// import BoundaryMap from 'map/BoundaryMap';
// import { ChipStack } from 'pages/components/ChipStack';

// export default function VmsDisplayView() {
//     const mapRef = React.useRef();
//     const [vmsGroups, setVmsGroups] = React.useState([]);
//     const [selectedVmsGroup, setSelectedVmsGroup] = React.useState([]);
//     const [boundaryGeoJson, setBoundaryGeoJson] = React.useState();

//     React.useEffect(() => {
//         ApiService.get("dashboard/Map/Boundary").then(response => {
//             if (response.status === 200) {
//                 const data = response.data;
//                 setBoundaryGeoJson(data)
//             }
//         })
//     }, []); 

//     React.useEffect(() => {
//         if(!boundaryGeoJson) 
//             return

//         ApiService.get("dashboard/VmsImage/GetItems?group=0&moduleType=0&project=0").then(response => {
//             if (response.status === 200) {
//                 const data = response.data;

//                 const groups = [
//                     {
//                         typeName: '문자',                  
//                         data: data.filter(p => p.project === 2)
//                     },
//                     {
//                         typeName: '혼합',
//                         data: data.filter(p => p.project === 4)
//                     },
//                     {
//                         typeName: '도형1',
//                         data: data.filter(p => p.project === 5 || p.project === 6)
//                     },
//                     {
//                         typeName: '도형2',
//                         data: data.filter(p => p.project === 7).slice(0, 6)
//                     },
//                     {
//                         typeName: '도형3',
//                         data: data.filter(p => p.project === 7).slice(6)
//                     },
//                 ];
//                 setVmsGroups(groups)
//             }
//         });
//     }, [boundaryGeoJson]);

//     React.useEffect(() => {
//         if(vmsGroups.length === 0)
//             return
        
//         let index = 0;
//         return repeatEffect(
//             () => {
//                 setSelectedVmsGroup(vmsGroups[index++])
//                 if (index === vmsGroups.length) {
//                     index = 0
//                 }
//             }, 
//             10)
//     }, [vmsGroups]);

//     React.useEffect(() => {
//         if(!selectedVmsGroup?.data)
//             return

//         // if (mapRef?.current?.SetVmsItems) {
//         //     mapRef.current.SetVmsItems(selectedVmsGroup.data);
//         // }  
//     }, [selectedVmsGroup]);

//     return (
//         <div>
//             <div style={{ fontSize: '1.5rem', fontWeight: 600, margin: '20px 0 10px 0' }}>
//                 VMS 현시 모니터링
//             </div>
//             <div style={{ height: '100%', width: '100%', display: 'grid', paddingLeft: 48, paddingRight: 48, paddingTop: 80, paddingBottom: 0 }}>
//                 <BoundaryMap
//                     ref={mapRef}
//                     boundaryGeoJson={boundaryGeoJson}
//                     initViewData={{ zoom: 11.8, center: [127.01288, 37.290] }}
//                 />
//             </div>
//             <ChipStack
//                 textItems={vmsGroups.map(group => group.typeName)} 
//                 selectedText={selectedVmsGroup?.typeName}
//             />
//         </div>
//     );
// }
